<template>
  <div class="mdm_group_page">
    <h3 class="title-page">{{ $t("department") }}</h3>
    <div>
      <div class="admin_container">
        <div class="mdm_main">
          <div>
            <v-btn
              class="ml-auto mb-5"
              color="primary"
              dark
              style="display: block"
              @click="onCreate"
            >
              <!--              <v-icon class="mr-2">mdi-plus</v-icon>-->
              {{ $t("create") }}
            </v-btn>
          </div>
          <table-with-filter
            fixed-header
            :headers="headers"
            :items="items"
            :page="configuration.page"
          >
            <template #filter.nameUz>
              <custom-input-text
                v-model="configuration.name"
                class="user_input no-margin"
                @input="onChangeFilter"
                clearable
              />
            </template>
            <template #item.depType="{ item: { depType } }">
              <span v-if="depType">{{ $t(depType.toLowerCase()) }}</span>
            </template>
            <template #item.action="{ item }">
              <v-tooltip color="#fff" left nudge-right="10" nudge-top="35">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="new_style"
                    @click="edit(item)"
                  >
                    <vue-icon icon="newPencilIcon" />
                  </v-btn>
                </template>
                <span>{{ $t("edit") }}</span>
              </v-tooltip>
              <v-tooltip color="#fff" left nudge-right="10" nudge-top="35">
                <template v-slot:activator="{ on, attrs }">
                  <!--If you add to 'btn_33' element 'disabled' class. it is disabled element  -->
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="new_style"
                    @click="deleteItem(item)"
                  >
                    <vue-icon icon="newTrashIcon" />
                  </v-btn>
                </template>
                <span>{{ $t("delete") }}</span>
              </v-tooltip>
            </template>
            <template #item.warehouseName="{ item }">
              <span v-if="item.warehouses && item.warehouses.length">
                {{
                  item.warehouses
                    .map((d) => {
                      return d.warehouseName;
                    })
                    .join(", ")
                }}
              </span>
            </template>
          </table-with-filter>
          <vue-pagination
            @update:limit="
              (limit) => {
                configuration.limit = limit;
                configuration.page = 1;
                changePage();
              }
            "
            v-model="configuration.page"
            :length="lastPage"
            @input="changePage"
            max-page
            :limit="configuration.limit"
          />
        </div>
      </div>
    </div>

    <v-dialog
      v-model="dialog"
      class="user_modal_dialog"
      max-width="528"
      persistent
      @click:outside="dialog = false"
    >
      <v-card>
        <validation-observer ref="form" v-slot="{ handleSubmit }">
          <v-form @submit.prevent="handleSubmit(save)">
            <v-card-title class="">
              <span class="headline title_modal_user">{{ formTitle }}</span>
              <v-icon class="info_modal_close" @click="dialog = false"
                >mdi-close</v-icon
              >
            </v-card-title>
            <v-card-text class="main_modal my-n2">
              <div class="py-2">
                <custom-input-text
                  v-model="formData.nameUz"
                  :label="$t('name') + ' UZ *'"
                  :placeholder="$t('name')"
                  class="user_input no-margin"
                  rules="required"
                ></custom-input-text>
              </div>
              <div class="py-2">
                <custom-input-text
                  v-model="formData.nameRu"
                  :label="$t('name') + ' RU *'"
                  :placeholder="$t('name')"
                  class="user_input no-margin"
                ></custom-input-text>
              </div>
              <div class="py-2">
                <custom-input-text
                  v-model="formData.nameEn"
                  :label="$t('name') + ' EN *'"
                  :placeholder="$t('name')"
                  class="user_input no-margin"
                ></custom-input-text>
              </div>
              <div class="py-2">
                <vue-select
                  ref="warehouseSelectRef"
                  infinite
                  multiple
                  rules="required"
                  @item-resolved="setWarehouse"
                  @next-page-resolved="
                    (data) => setWarehouse([...warehouseList, ...data])
                  "
                  :get-item-promise="
                    ({ text, page }) =>
                      $store.dispatch('getWareHouses', {
                        page,
                        name: text,
                        limit: 15,
                      })
                  "
                  v-model="formData.warehouseIds"
                  :items="warehouseList"
                  :label="$t('warehouse')"
                  class="product-select-in-modal"
                ></vue-select>
              </div>
              <div class="py-2">
                <vue-select
                  ref="parentSelect"
                  infinite
                  clearable
                  @item-resolved="setParentItem"
                  @next-page-resolved="
                    (data) => setParentItem([...parentItems, ...data])
                  "
                  :get-item-promise="
                    ({ text, page }) =>
                      $store.dispatch('getDepartments', {
                        limit: 15,
                        page,
                        name: text,
                      })
                  "
                  v-model="formData.parentId"
                  :items="parentItems"
                  :label="$t('mainDepartment')"
                  class="product-select-in-modal"
                ></vue-select>
              </div>
              <div class="py-2">
                <custom-select
                  v-model="formData.depType"
                  :items="DEPARTMENT_TYPES"
                  :label="$t('divisionType')"
                  class="user_input no-margin"
                  item-text="text"
                  item-value="value"
                  rules="required"
                ></custom-select>
              </div>

              <div class="py-2">
                <custom-input-text
                  v-model="formData.chatId"
                  label="Telegram chat Id"
                  placeholder="Chat Id"
                  class="user_input no-margin"
                ></custom-input-text>
              </div>
            </v-card-text>
            <v-card-actions class="footer_modal_user py-8">
              <div class="row">
                <div
                  class="d-flex flex-wrap justify-space-around button_modal_add mr-3 mt-3"
                >
                  <v-btn color="primary" dark type="submit"
                    >{{ $t("save") }}
                  </v-btn>
                </div>
              </div>
            </v-card-actions>
          </v-form>
        </validation-observer>
      </v-card>
    </v-dialog>
    <warning-dialog
      description="deleteDepartmentHint"
      v-model="confirmDialog"
      @apply="deleteItemHandler"
    ></warning-dialog>
  </div>
</template>

<script>
import WarningDialog from "@/components/ui/prompt/warning-dialog";
import { DEPARTMENT_TYPES } from "@/utils/constants";
import VueSelect from "@/components/ui/vue-select/VueSelect";
import TableWithFilter from "@/components/ui/table/TableWithFilter";
import { debounce, getValueByKey } from "@/utils/pureFunctions";
import VuePagination from "@/components/ui/vue-pagination/VuePagination";

const currentDepartmentItem = {
  id: null,
  nameEn: null,
  nameRu: null,
  nameUz: null,
  warehouseIds: [],
  parentId: null,
  depType: null,
  chatId: null,
};
export default {
  name: "attribute-reference",
  data() {
    return {
      confirmDialog: false,
      dialog: false,
      items: [],
      parentItems: [],
      warehouses: [],
      warehouseList: [],
      formData: { ...currentDepartmentItem },
      configuration: {
        name: null,
        limit: "50",
        page: 1,
      },
      lastPage: 0,
    };
  },
  computed: {
    DEPARTMENT_TYPES() {
      return DEPARTMENT_TYPES.map((item) => {
        return {
          text: this.$t(item.text),
          value: item.value,
        };
      });
    },
    isEditingItem() {
      return !this.formData.id;
    },
    formTitle() {
      return this.isEditingItem ? this.$t("create") : this.$t("editGroup");
    },
    headers() {
      return [
        {
          text: this.$t("name") + " UZ",
          value: "nameUz",
        },
        {
          text: this.$t("name") + " RU",
          value: "nameRu",
        },
        {
          text: this.$t("name") + " EN",
          value: "nameEn",
        },
        {
          text: this.$t("warehouse"),
          value: "warehouseName",
        },
        {
          text: this.$t("mainDepartment"),
          value: "parentName",
        },
        {
          text: this.$t("divisionType"),
          value: "depType",
        },
        {
          text: this.$t("action"),
          sortable: false,
          value: "action",
        },
      ];
    },
  },
  components: {
    VuePagination,
    TableWithFilter,
    VueSelect,
    WarningDialog,
  },
  watch: {
    confirmDialog(val) {
      if (!val) this.clearForm();
    },
    dialog(val) {
      if (!val) this.clearForm();
    },
  },
  methods: {
    setParentItem(parentItems) {
      this.parentItems = parentItems;
    },
    setWarehouse(warehouses) {
      this.warehouseList = warehouses;
    },
    onCreate() {
      this.dialog = true;
    },
    onChangeFilter: debounce(function () {
      this.$router.push({ query: { ...this.configuration } });
      this.configuration.page = 1;
      this.getItems();
    }, 300),
    async save() {
      this.showLoading();
      try {
        const formData = { ...this.formData };
        if (!formData.nameRu) {
          formData.nameRu = formData.nameUz;
        }
        if (!formData.nameEn) {
          formData.nameEn = formData.nameUz;
        }
        await this.$http.post("deparments", formData);
        await this.getItems();
        this.dialog = false;
        this.clearForm();
        this.setSuccess({
          title: this.$t("successfullySaved"),
        });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    clearForm() {
      const { form } = this.$refs;
      this.formData = { ...currentDepartmentItem, warehouseIds: [] };
      if (form) form.reset();
    },
    async deleteItemHandler() {
      try {
        this.showLoading();
        await this.$http.delete(`deparments/delete/${this.formData.id}`);
        this.setSuccess({ text: this.$t("successfullyDeleted") });
        this.clearForm();
        if (this.configuration.page !== 1 && this.items.length === 1) {
          this.configuration.page--;
        }
        await this.getItems();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    deleteItem(item) {
      this.confirmDialog = true;
      this.formData = { ...this.formData, id: item.id };
    },
    /**
     * @typedef Item
     * @property parentName {string}
     * @param item {Item}
     */
    edit(item) {
      setTimeout(() => {
        if (item.parentId) {
          const { parentSelect } = this.$refs;
          if (parentSelect) parentSelect.reset();
          this.parentItems = [{ name: item.parentName, id: item.parentId }];
        }
        if (item.warehouses) {
          const { warehouseSelectRef } = this.$refs;

          const warehouses = item.warehouses.map((item) => {
            return {
              id: item.warehouseId,
              name: item.warehouseName,
            };
          });
          this.warehouseList = warehouses;
          this.$set(
            this.formData,
            "warehouseIds",
            warehouses.map((item) => {
              return item.id;
            })
          );
          if (warehouseSelectRef) {
            warehouseSelectRef.reset();
            warehouseSelectRef.setCachedItems(warehouses);
          }
        }
      }, 50);
      this.dialog = true;
      this.formData = getValueByKey(this.formData, item);
    },
    changePage() {
      this.$router.replace({ query: { ...this.configuration } });
      this.getItems();
    },
    async getItems() {
      this.showLoading();
      try {
        const { page } = this.configuration;
        const { data, lastPage } = await this.$store.dispatch(
          "getDepartments",
          { ...this.configuration, page: page - 1 }
        );
        this.lastPage = lastPage;
        this.items = data;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
  },
  async created() {
    const { page } = this.$route.query;
    if (page) {
      this.configuration.page = +page;
    }
    const options = getValueByKey(this.configuration, this.$route.query);
    if (options.page && !isNaN(options.page)) options.page = +options.page;
    this.configuration = options;

    await this.getItems();
  },
};
</script>

<style scoped></style>
